module.exports = __webpack_public_path__ + "img/mobile.51fdf2f7.webp";